import authentication from 'services/authentication';
import type { Route } from 'services/router/contracts';

const shouldDisplayLayout = (route: Route): boolean => {
  return authentication.isAuthenticated() && ((route?.meta?.layout ?? true) as boolean);
};

export { shouldDisplayLayout };
